import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { IStorageDashboardRepository } from "./IStorageDashboardRepository";

@Injectable({
  providedIn: 'root'
})
export class StorageDashboardRepository
  extends GenericRepository<any>
  implements IStorageDashboardRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/StorageDashboard', environment.urlAddress);
  }

  GetDashboardData(): Observable<ResponseModel> {
  return this.Get('GetDashboardData') as Observable<ResponseModel>;
}
}